/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The action the referred user must take to qualify the referrer for the reward. FIRST_ORDER is the legacy DevourGO food-ordering trigger (referee places a paid order ≥ minPaymentRequired). LEVEL_REACHED + FIRST_QUEST_COMPLETED + FIRST_FUEL_PURCHASE are gaming triggers for DevourPlay — they ignore minPaymentRequired and use triggerValue (e.g. the level number for LEVEL_REACHED). triggerCopy is the human-readable label shown in the on-page strings.
 * @export
 */
export const ReferralTriggerType = {
    FIRST_ORDER: 'FIRST_ORDER',
    LEVEL_REACHED: 'LEVEL_REACHED',
    FIRST_QUEST_COMPLETED: 'FIRST_QUEST_COMPLETED',
    FIRST_FUEL_PURCHASE: 'FIRST_FUEL_PURCHASE'
} as const;
export type ReferralTriggerType = typeof ReferralTriggerType[keyof typeof ReferralTriggerType];


export function instanceOfReferralTriggerType(value: any): boolean {
    for (const key in ReferralTriggerType) {
        if (Object.prototype.hasOwnProperty.call(ReferralTriggerType, key)) {
            if (ReferralTriggerType[key as keyof typeof ReferralTriggerType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReferralTriggerTypeFromJSON(json: any): ReferralTriggerType {
    return ReferralTriggerTypeFromJSONTyped(json, false);
}

export function ReferralTriggerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralTriggerType {
    return json as ReferralTriggerType;
}

export function ReferralTriggerTypeToJSON(value?: ReferralTriggerType | null): any {
    return value as any;
}

export function ReferralTriggerTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ReferralTriggerType {
    return value as ReferralTriggerType;
}

